export class RequestFilters {
  requestIds?: string[];
  dateFrom?: string;
  dateTo?: string;
  organizationIds?: string[];
  accountNames?: string[];
  types?: string[];
  statuses?: string[];
}
